import { styled } from '@util/tw'

export const H1 = styled('h1', 'text-3xl font-semibold')
export const H2 = styled('h2', 'text-gray-600 text-lg')
export const H3 = styled('h3', 'text-xl font-thin')
